import { render, staticRenderFns } from "./settlemanetXMYPrint.vue?vue&type=template&id=51fc4a16&scoped=true&"
import script from "./settlemanetXMYPrint.vue?vue&type=script&lang=js&"
export * from "./settlemanetXMYPrint.vue?vue&type=script&lang=js&"
import style0 from "./settlemanetXMYPrint.vue?vue&type=style&index=0&id=51fc4a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc4a16",
  null
  
)

export default component.exports